import { t as createFetchClient } from "./createFetchClient-CkHdS_IG.js";
//#region src/fetchClient/createOpenapiFetchClient.ts
const createOpenapiFetchClient = (defaultOptions) => createFetchClient(defaultOptions);
//#endregion
export { createOpenapiFetchClient as t };

//# sourceMappingURL=createOpenapiFetchClient-DXiMv9WL.js.map